import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/comming-soon.svg'


const _hoisted_1 = { class: "container-dashboard" }

import Card from 'primevue/card'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card), { class: "card-no-shadow" }, {
      content: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("div", {
          class: "flex items-center justify-center",
          style: {"min-height":"85vh"}
        }, [
          _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("img", {
              class: "mx-auto",
              src: _imports_0,
              alt: "comming-soon"
            }),
            _createElementVNode("div", { class: "mt-12px text-60px font-black text-bluegrey-dashboard" }, "Coming Soon!"),
            _createElementVNode("div", { class: "text-xl font-normal text-bluegrey-dashboard" }, "Fitur ini belum siap, Kami sedang mempersiapkannya untuk Anda")
          ])
        ], -1)
      ])),
      _: 1
    })
  ]))
}
}

})